function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { XYChartDefaultTheme } from "./XYChartDefaultTheme";
import { Container } from "../../core/render/Container";
import { Rectangle } from "../../core/render/Rectangle";
import { SerialChart } from "../../core/render/SerialChart";
import { ListAutoDispose } from "../../core/util/List";
import { p100 } from "../../core/util/Percent";
import { Color } from "../../core/util/Color";
import { Button } from "../../core/render/Button";
import { Graphics } from "../../core/render/Graphics";
import { Percent } from "../../core/util/Percent";
import * as $array from "../../core/util/Array";
import * as $type from "../../core/util/Type";
import * as $order from "../../core/util/Order";
import * as $object from "../../core/util/Object";
import * as $utils from "../../core/util/Utils";
/**
 * Creates an XY chart.
 *
 * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/} for more info
 * @important
 */
export var XYChart = /*#__PURE__*/function (_SerialChart) {
  _inherits(XYChart, _SerialChart);
  var _super = _createSuper(XYChart);
  function XYChart() {
    var _this;
    _classCallCheck(this, XYChart);
    _this = _super.apply(this, arguments);
    /**
     * A list of horizontal axes.
     */
    Object.defineProperty(_assertThisInitialized(_this), "xAxes", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListAutoDispose()
    });
    /**
     * A list of vertical axes.
     */
    Object.defineProperty(_assertThisInitialized(_this), "yAxes", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListAutoDispose()
    });
    /**
     * A [[Container]] located on top of the chart, used to store top horizontal
     * axes.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "topAxesContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this.chartContainer.children.push(Container.new(_this._root, {
        width: p100,
        layout: _this._root.verticalLayout
      }))
    });
    /**
     * A [[Container]] located in the middle the chart, used to store vertical axes
     * and plot area container.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "yAxesAndPlotContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this.chartContainer.children.push(Container.new(_this._root, {
        width: p100,
        height: p100,
        layout: _this._root.horizontalLayout
      }))
    });
    /**
     * A [[Container]] located on bottom of the chart, used to store bottom
     * horizontal axes.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "bottomAxesContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this.chartContainer.children.push(Container.new(_this._root, {
        width: p100,
        layout: _this._root.verticalLayout
      }))
    });
    /**
     * A [[Container]] located on left of the chart, used to store left-hand
     * vertical axes.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "leftAxesContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this.yAxesAndPlotContainer.children.push(Container.new(_this._root, {
        height: p100,
        layout: _this._root.horizontalLayout
      }))
    });
    /**
     * A [[Container]] located in the middle of the chart, used to store plotContainer and topPlotContainer
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "plotsContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this.yAxesAndPlotContainer.children.push(Container.new(_this._root, {
        width: p100,
        height: p100,
        maskContent: false
      }))
    });
    /**
     * A [[Container]] located in the middle of the chart, used to store actual
     * plots (series).
     *
     * NOTE: `plotContainer` will automatically have its `background` preset. If
     * you need to modify background or outline for chart's plot area, you can
     * use `plotContainer.get("background")` for that.*
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "plotContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this.plotsContainer.children.push(Container.new(_this._root, {
        width: p100,
        height: p100
      }))
    });
    /**
     * A [[Container]] used for any elements that need to be displayed over
     * regular `plotContainer`.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "topPlotContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this.plotsContainer.children.push(Container.new(_this._root, {
        width: p100,
        height: p100
      }))
    });
    /**
     * A [[Container]] axis grid elements are stored in.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "gridContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this.plotContainer.children.push(Container.new(_this._root, {
        width: p100,
        height: p100,
        isMeasured: false
      }))
    });
    /**
     * A [[Container]] axis background grid elements are stored in.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "topGridContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: Container.new(_this._root, {
        width: p100,
        height: p100,
        isMeasured: false
      })
    });
    /**
     * A [[Container]] located on right of the chart, used to store right-hand
     * vertical axes.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/xy-chart-containers/} for more info
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "rightAxesContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this.yAxesAndPlotContainer.children.push(Container.new(_this._root, {
        height: p100,
        layout: _this._root.horizontalLayout
      }))
    });
    /**
     * A [[Container]] axis headers are stored in.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/axes/axis-headers/} for more info
     * @default Container.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "axisHeadersContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this.plotContainer.children.push(Container.new(_this._root, {}))
    });
    /**
     * A button that is shown when chart is not fully zoomed out.
     *
     * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/zoom-and-pan/#Zoom_out_button} for more info
     * @default Button.new()
     */
    Object.defineProperty(_assertThisInitialized(_this), "zoomOutButton", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this.topPlotContainer.children.push(Button.new(_this._root, {
        themeTags: ["zoom"],
        icon: Graphics.new(_this._root, {
          themeTags: ["button", "icon"]
        })
      }))
    });
    Object.defineProperty(_assertThisInitialized(_this), "_movePoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {
        x: 0,
        y: 0
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "_wheelDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_otherCharts", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_movePoints", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(_assertThisInitialized(_this), "_downStartX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_downEndX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_downStartY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_downEndY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    return _this;
  }
  _createClass(XYChart, [{
    key: "_afterNew",
    value: function _afterNew() {
      var _this2 = this;
      this._defaultThemes.push(XYChartDefaultTheme.new(this._root));
      _get(_getPrototypeOf(XYChart.prototype), "_afterNew", this).call(this);
      this._disposers.push(this.xAxes);
      this._disposers.push(this.yAxes);
      var root = this._root;
      var verticalLayout = this._root.verticalLayout;
      var zoomOutButton = this.zoomOutButton;
      zoomOutButton.events.on("click", function () {
        _this2.zoomOut();
      });
      zoomOutButton.set("opacity", 0);
      zoomOutButton.states.lookup("default").set("opacity", 1);
      this.chartContainer.set("layout", verticalLayout);
      var plotContainer = this.plotContainer;
      plotContainer.children.push(this.seriesContainer);
      this._disposers.push(this._processAxis(this.xAxes, this.bottomAxesContainer));
      this._disposers.push(this._processAxis(this.yAxes, this.leftAxesContainer));
      plotContainer.children.push(this.topGridContainer);
      plotContainer.children.push(this.bulletsContainer);
      // Setting trasnparent background so that full body of the plot container
      // is interactive
      plotContainer.set("interactive", true);
      plotContainer.set("interactiveChildren", false);
      plotContainer.set("background", Rectangle.new(root, {
        themeTags: ["xy", "background"],
        fill: Color.fromHex(0x000000),
        fillOpacity: 0
      }));
      this._disposers.push(plotContainer.events.on("pointerdown", function (event) {
        _this2._handlePlotDown(event.originalEvent);
      }));
      this._disposers.push(plotContainer.events.on("globalpointerup", function (event) {
        _this2._handlePlotUp(event.originalEvent);
      }));
      this._disposers.push(plotContainer.events.on("globalpointermove", function (event) {
        _this2._handlePlotMove(event.originalEvent);
      }));
      this._maskGrid();
      this._setUpTouch();
    }
  }, {
    key: "_beforeChanged",
    value: function _beforeChanged() {
      _get(_getPrototypeOf(XYChart.prototype), "_beforeChanged", this).call(this);
      if (this.isDirty("pinchZoomX") || this.isDirty("pinchZoomY") || this.get("panX") || this.get("panY")) {
        this._setUpTouch();
      }
    }
  }, {
    key: "_setUpTouch",
    value: function _setUpTouch() {
      if (!this.plotContainer._display.cancelTouch) {
        this.plotContainer._display.cancelTouch = this.get("pinchZoomX") || this.get("pinchZoomY") || this.get("panX") || this.get("panY") ? true : false;
      }
    }
  }, {
    key: "_maskGrid",
    value: function _maskGrid() {
      this.gridContainer.set("maskContent", true);
      this.topGridContainer.set("maskContent", true);
    }
  }, {
    key: "_removeSeries",
    value: function _removeSeries(series) {
      var xAxis = series.get("xAxis");
      if (xAxis) {
        $array.remove(xAxis.series, series);
        xAxis.markDirtyExtremes();
      }
      var yAxis = series.get("yAxis");
      if (yAxis) {
        $array.remove(yAxis.series, series);
        yAxis.markDirtyExtremes();
      }
      var cursor = this.get("cursor");
      if (cursor) {
        var snapToSeries = cursor.get("snapToSeries");
        if (snapToSeries) {
          $array.remove(snapToSeries, series);
        }
      }
      _get(_getPrototypeOf(XYChart.prototype), "_removeSeries", this).call(this, series);
    }
    /**
     * This method is invoked when mouse wheel is used over chart's plot
     * container, and handles zooming/pan.
     *
     * You can invoke this method manually, if you need to mimic chart's wheel
     * behavior over other elements of the chart.
     */
  }, {
    key: "handleWheel",
    value: function handleWheel(event) {
      var _this3 = this;
      var wheelX = this.get("wheelX");
      var wheelY = this.get("wheelY");
      var plotContainer = this.plotContainer;
      var wheelEvent = event.originalEvent;
      // Ignore wheel event if it is happening on a non-chart element, e.g. if
      // some page element is over the chart.
      if ($utils.isLocalEvent(wheelEvent, this)) {
        wheelEvent.preventDefault();
      } else {
        return;
      }
      var plotPoint = plotContainer.toLocal(this._root.documentPointToRoot({
        x: wheelEvent.clientX,
        y: wheelEvent.clientY
      }));
      var wheelStep = this.get("wheelStep", 0.2);
      var shiftY = wheelEvent.deltaY / 100;
      var shiftX = wheelEvent.deltaX / 100;
      var wheelZoomPositionX = this.get("wheelZoomPositionX");
      var wheelZoomPositionY = this.get("wheelZoomPositionY");
      if ((wheelX === "zoomX" || wheelX === "zoomXY") && shiftX != 0) {
        this.xAxes.each(function (axis) {
          if (axis.get("zoomX")) {
            var start = axis.get("start");
            var end = axis.get("end");
            var position = axis.fixPosition(plotPoint.x / plotContainer.width());
            if (wheelZoomPositionX != null) {
              position = wheelZoomPositionX;
            }
            var newStart = start - wheelStep * (end - start) * shiftX * position;
            var newEnd = end + wheelStep * (end - start) * shiftX * (1 - position);
            if (1 / (newEnd - newStart) < axis.getPrivate("maxZoomFactor", Infinity) / axis.get("minZoomCount", 1)) {
              _this3._handleWheelAnimation(axis.zoom(newStart, newEnd));
            }
          }
        });
      }
      if ((wheelY === "zoomX" || wheelY === "zoomXY") && shiftY != 0) {
        this.xAxes.each(function (axis) {
          if (axis.get("zoomX")) {
            var start = axis.get("start");
            var end = axis.get("end");
            var position = axis.fixPosition(plotPoint.x / plotContainer.width());
            if (wheelZoomPositionX != null) {
              position = wheelZoomPositionX;
            }
            var newStart = start - wheelStep * (end - start) * shiftY * position;
            var newEnd = end + wheelStep * (end - start) * shiftY * (1 - position);
            if (1 / (newEnd - newStart) < axis.getPrivate("maxZoomFactor", Infinity) / axis.get("minZoomCount", 1)) {
              _this3._handleWheelAnimation(axis.zoom(newStart, newEnd));
            }
          }
        });
      }
      if ((wheelX === "zoomY" || wheelX === "zoomXY") && shiftX != 0) {
        this.yAxes.each(function (axis) {
          if (axis.get("zoomY")) {
            var start = axis.get("start");
            var end = axis.get("end");
            var position = axis.fixPosition(plotPoint.y / plotContainer.height());
            if (wheelZoomPositionY != null) {
              position = wheelZoomPositionY;
            }
            var newStart = start - wheelStep * (end - start) * shiftX * position;
            var newEnd = end + wheelStep * (end - start) * shiftX * (1 - position);
            if (1 / (newEnd - newStart) < axis.getPrivate("maxZoomFactor", Infinity) / axis.get("minZoomCount", 1)) {
              _this3._handleWheelAnimation(axis.zoom(newStart, newEnd));
            }
          }
        });
      }
      if ((wheelY === "zoomY" || wheelY === "zoomXY") && shiftY != 0) {
        this.yAxes.each(function (axis) {
          if (axis.get("zoomY")) {
            var start = axis.get("start");
            var end = axis.get("end");
            var position = axis.fixPosition(plotPoint.y / plotContainer.height());
            if (wheelZoomPositionY != null) {
              position = wheelZoomPositionY;
            }
            var newStart = start - wheelStep * (end - start) * shiftY * position;
            var newEnd = end + wheelStep * (end - start) * shiftY * (1 - position);
            if (1 / (newEnd - newStart) < axis.getPrivate("maxZoomFactor", Infinity) / axis.get("minZoomCount", 1)) {
              _this3._handleWheelAnimation(axis.zoom(newStart, newEnd));
            }
          }
        });
      }
      if ((wheelX === "panX" || wheelX === "panXY") && shiftX != 0) {
        this.xAxes.each(function (axis) {
          if (axis.get("panX")) {
            var start = axis.get("start");
            var end = axis.get("end");
            var delta = _this3._getWheelSign(axis) * wheelStep * (end - start) * shiftX;
            var newStart = start + delta;
            var newEnd = end + delta;
            var se = _this3._fixWheel(newStart, newEnd);
            newStart = se[0];
            newEnd = se[1];
            _this3._handleWheelAnimation(axis.zoom(newStart, newEnd));
          }
        });
      }
      if ((wheelY === "panX" || wheelY === "panXY") && shiftY != 0) {
        this.xAxes.each(function (axis) {
          if (axis.get("panX")) {
            var start = axis.get("start");
            var end = axis.get("end");
            var delta = _this3._getWheelSign(axis) * wheelStep * (end - start) * shiftY;
            var newStart = start + delta;
            var newEnd = end + delta;
            var se = _this3._fixWheel(newStart, newEnd);
            newStart = se[0];
            newEnd = se[1];
            _this3._handleWheelAnimation(axis.zoom(newStart, newEnd));
          }
        });
      }
      if ((wheelX === "panY" || wheelX === "panXY") && shiftX != 0) {
        this.yAxes.each(function (axis) {
          if (axis.get("panY")) {
            var start = axis.get("start");
            var end = axis.get("end");
            var delta = _this3._getWheelSign(axis) * wheelStep * (end - start) * shiftX;
            var newStart = start + delta;
            var newEnd = end + delta;
            var se = _this3._fixWheel(newStart, newEnd);
            newStart = se[0];
            newEnd = se[1];
            _this3._handleWheelAnimation(axis.zoom(newStart, newEnd));
          }
        });
      }
      if ((wheelY === "panY" || wheelY === "panXY") && shiftY != 0) {
        this.yAxes.each(function (axis) {
          if (axis.get("panY")) {
            var start = axis.get("start");
            var end = axis.get("end");
            var delta = _this3._getWheelSign(axis) * wheelStep * (end - start) * shiftY;
            var newStart = start - delta;
            var newEnd = end - delta;
            var se = _this3._fixWheel(newStart, newEnd);
            newStart = se[0];
            newEnd = se[1];
            _this3._handleWheelAnimation(axis.zoom(newStart, newEnd));
          }
        });
      }
    }
  }, {
    key: "_handleSetWheel",
    value: function _handleSetWheel() {
      var _this4 = this;
      var wheelX = this.get("wheelX");
      var wheelY = this.get("wheelY");
      var plotContainer = this.plotContainer;
      if (wheelX !== "none" || wheelY !== "none") {
        this._wheelDp = plotContainer.events.on("wheel", function (event) {
          _this4.handleWheel(event);
        });
        this._disposers.push(this._wheelDp);
      } else {
        if (this._wheelDp) {
          this._wheelDp.dispose();
        }
      }
    }
  }, {
    key: "_getWheelSign",
    value: function _getWheelSign(axis) {
      var sign = 1;
      if (axis.get("renderer").get("inversed")) {
        sign = -1;
      }
      return sign;
    }
  }, {
    key: "_fixWheel",
    value: function _fixWheel(start, end) {
      var diff = end - start;
      if (start < 0) {
        start = 0;
        end = start + diff;
      }
      if (end > 1) {
        end = 1;
        start = end - diff;
      }
      return [start, end];
    }
  }, {
    key: "_handlePlotDown",
    value: function _handlePlotDown(event) {
      if (event.button == 2) {
        return;
      }
      var plotContainer = this.plotContainer;
      var local = plotContainer.toLocal(this._root.documentPointToRoot({
        x: event.clientX,
        y: event.clientY
      }));
      if (this.get("pinchZoomX") || this.get("pinchZoomY")) {
        var touchEvent = event;
        var pointerId = touchEvent.pointerId;
        if (pointerId) {
          if ($object.keys(plotContainer._downPoints).length > 0) {
            var xAxis = this.xAxes.getIndex(0);
            var yAxis = this.yAxes.getIndex(0);
            if (xAxis) {
              this._downStartX = xAxis.get("start", 0);
              this._downEndX = xAxis.get("end", 1);
            }
            if (yAxis) {
              this._downStartY = yAxis.get("start", 0);
              this._downEndY = yAxis.get("end", 1);
            }
          }
        }
      }
      if (this.get("panX") || this.get("panY")) {
        if (local.x >= 0 && local.y >= 0 && local.x <= plotContainer.width() && local.y <= this.height()) {
          //this._downPoint = local;
          this._downPoint = {
            x: event.clientX,
            y: event.clientY
          };
          var panX = this.get("panX");
          var panY = this.get("panY");
          if (panX) {
            this.xAxes.each(function (axis) {
              axis._panStart = axis.get("start");
              axis._panEnd = axis.get("end");
            });
          }
          if (panY) {
            this.yAxes.each(function (axis) {
              axis._panStart = axis.get("start");
              axis._panEnd = axis.get("end");
            });
          }
          var eventType = "panstarted";
          if (this.events.isEnabled(eventType)) {
            this.events.dispatch(eventType, {
              type: eventType,
              target: this,
              originalEvent: event
            });
          }
        }
      }
    }
  }, {
    key: "_handleWheelAnimation",
    value: function _handleWheelAnimation(animation) {
      var _this5 = this;
      if (animation) {
        animation.events.on("stopped", function () {
          _this5._dispatchWheelAnimation();
        });
      } else {
        this._dispatchWheelAnimation();
      }
    }
  }, {
    key: "_dispatchWheelAnimation",
    value: function _dispatchWheelAnimation() {
      var eventType = "wheelended";
      if (this.events.isEnabled(eventType)) {
        this.events.dispatch(eventType, {
          type: eventType,
          target: this
        });
      }
    }
  }, {
    key: "_handlePlotUp",
    value: function _handlePlotUp(event) {
      var downPoint = this._downPoint;
      if (downPoint) {
        if (this.get("panX") || this.get("panY")) {
          var local = this.plotContainer.toLocal(this._root.documentPointToRoot({
            x: event.clientX,
            y: event.clientY
          }));
          if (local.x == downPoint.x && local.y == downPoint.y) {
            var _eventType = "pancancelled";
            if (this.events.isEnabled(_eventType)) {
              this.events.dispatch(_eventType, {
                type: _eventType,
                target: this,
                originalEvent: event
              });
            }
          }
          var eventType = "panended";
          if (this.events.isEnabled(eventType)) {
            this.events.dispatch(eventType, {
              type: eventType,
              target: this,
              originalEvent: event
            });
          }
        }
      }
      // TODO: handle multitouch
      this._downPoint = undefined;
      this.xAxes.each(function (xAxis) {
        xAxis._isPanning = false;
      });
      this.yAxes.each(function (yAxis) {
        yAxis._isPanning = false;
      });
    }
  }, {
    key: "_handlePlotMove",
    value: function _handlePlotMove(event) {
      var plotContainer = this.plotContainer;
      if (this.get("pinchZoomX") || this.get("pinchZoomY")) {
        var touchEvent = event;
        var pointerId = touchEvent.pointerId;
        if (pointerId) {
          this._movePoints[pointerId] = this._root.documentPointToRoot({
            x: event.clientX,
            y: event.clientY
          });
          if ($object.keys(plotContainer._downPoints).length > 1) {
            this._handlePinch();
            return;
          }
        }
      }
      var downPoint = this._downPoint;
      if (downPoint) {
        downPoint = plotContainer.toLocal(this._root.documentPointToRoot(downPoint));
        var local = plotContainer.toLocal(this._root.documentPointToRoot({
          x: event.clientX,
          y: event.clientY
        }));
        var panX = this.get("panX");
        var panY = this.get("panY");
        if (panX) {
          var scrollbarX = this.get("scrollbarX");
          if (scrollbarX) {
            scrollbarX.events.disableType("rangechanged");
          }
          this.xAxes.each(function (axis) {
            if (axis.get("panX")) {
              axis._isPanning = true;
              //const maxDeviation = axis.get("maxDeviation", 0);
              var panStart = axis._panStart;
              var panEnd = axis._panEnd;
              var difference = panEnd - panStart;
              var deltaX = difference * (downPoint.x - local.x) / plotContainer.width();
              if (axis.get("renderer").get("inversed")) {
                deltaX *= -1;
              }
              var start = panStart + deltaX;
              var end = panEnd + deltaX;
              if (end - start < 1 + axis.get("maxDeviation", 1) * 2) {
                axis.set("start", start);
                axis.set("end", end);
              }
            }
          });
          if (scrollbarX) {
            scrollbarX.events.enableType("rangechanged");
          }
        }
        if (panY) {
          var scrollbarY = this.get("scrollbarY");
          if (scrollbarY) {
            scrollbarY.events.disableType("rangechanged");
          }
          this.yAxes.each(function (axis) {
            if (axis.get("panY")) {
              axis._isPanning = true;
              //const maxDeviation = axis.get("maxDeviation", 0);
              var panStart = axis._panStart;
              var panEnd = axis._panEnd;
              var difference = panEnd - panStart;
              var deltaY = difference * (downPoint.y - local.y) / plotContainer.height();
              if (axis.get("renderer").get("inversed")) {
                deltaY *= -1;
              }
              var start = panStart - deltaY;
              var end = panEnd - deltaY;
              if (end - start < 1 + axis.get("maxDeviation", 1) * 2) {
                axis.set("start", start);
                axis.set("end", end);
              }
            }
          });
          if (scrollbarY) {
            scrollbarY.events.enableType("rangechanged");
          }
        }
      }
    }
  }, {
    key: "_handlePinch",
    value: function _handlePinch() {
      var _this6 = this;
      var plotContainer = this.plotContainer;
      var i = 0;
      var downPoints = [];
      var movePoints = [];
      $object.each(plotContainer._downPoints, function (k, point) {
        downPoints[i] = point;
        var movePoint = _this6._movePoints[k];
        if (movePoint) {
          movePoints[i] = movePoint;
        }
        i++;
      });
      if (downPoints.length > 1 && movePoints.length > 1) {
        var w = plotContainer.width();
        var h = plotContainer.height();
        var downPoint0 = downPoints[0];
        var downPoint1 = downPoints[1];
        var movePoint0 = movePoints[0];
        var movePoint1 = movePoints[1];
        if (downPoint0 && downPoint1 && movePoint0 && movePoint1) {
          movePoint0 = plotContainer.toLocal(movePoint0);
          movePoint1 = plotContainer.toLocal(movePoint1);
          downPoint0 = plotContainer.toLocal(downPoint0);
          downPoint1 = plotContainer.toLocal(downPoint1);
          if (this.get("pinchZoomX")) {
            var downStartX = this._downStartX;
            var downEndX = this._downEndX;
            if (downStartX != null && downEndX != null) {
              if (downPoint0.x > downPoint1.x) {
                var _ref = [downPoint1, downPoint0];
                downPoint0 = _ref[0];
                downPoint1 = _ref[1];
                var _ref2 = [movePoint1, movePoint0];
                movePoint0 = _ref2[0];
                movePoint1 = _ref2[1];
              }
              var downPos0 = downStartX + downPoint0.x / w * (downEndX - downStartX);
              var downPos1 = downStartX + downPoint1.x / w * (downEndX - downStartX);
              var movePos0 = downStartX + movePoint0.x / w * (downEndX - downStartX);
              var movePos1 = downStartX + movePoint1.x / w * (downEndX - downStartX);
              var initialDistance = Math.max(0.001, downPos1 - downPos0);
              var currentDistance = Math.max(0.001, movePos1 - movePos0);
              var d = initialDistance / currentDistance;
              var s = downStartX * d + downPos0 - movePos0 * d;
              var e = downEndX * d + downPos1 - movePos1 * d;
              this.xAxes.each(function (xAxis) {
                var sa = xAxis.fixPosition(s);
                var ea = xAxis.fixPosition(e);
                xAxis.zoom(sa, ea, 0);
              });
            }
          }
          if (this.get("pinchZoomY")) {
            var downStartY = this._downStartY;
            var downEndY = this._downEndY;
            if (downStartY != null && downEndY != null) {
              if (downPoint0.y < downPoint1.y) {
                var _ref3 = [downPoint1, downPoint0];
                downPoint0 = _ref3[0];
                downPoint1 = _ref3[1];
                var _ref4 = [movePoint1, movePoint0];
                movePoint0 = _ref4[0];
                movePoint1 = _ref4[1];
              }
              var _downPos = downStartY + (1 - downPoint0.y / h) * (downEndY - downStartY);
              var _downPos2 = downStartY + (1 - downPoint1.y / h) * (downEndY - downStartY);
              var _movePos = downStartY + (1 - movePoint0.y / h) * (downEndY - downStartY);
              var _movePos2 = downStartY + (1 - movePoint1.y / h) * (downEndY - downStartY);
              var _initialDistance = Math.max(0.001, _downPos2 - _downPos);
              var _currentDistance = Math.max(0.001, _movePos2 - _movePos);
              var _d = _initialDistance / _currentDistance;
              var _s = downStartY * _d + _downPos - _movePos * _d;
              var _e = downEndY * _d + _downPos2 - _movePos2 * _d;
              this.yAxes.each(function (yAxis) {
                var sa = yAxis.fixPosition(_s);
                var ea = yAxis.fixPosition(_e);
                yAxis.zoom(sa, ea, 0);
              });
            }
          }
        }
      }
    }
  }, {
    key: "_handleCursorPosition",
    value: function _handleCursorPosition() {
      var cursor = this.get("cursor");
      if (cursor) {
        var cursorPoint = cursor.getPrivate("point");
        var snapToSeries = cursor.get("snapToSeries");
        if (cursor._downPoint) {
          snapToSeries = undefined;
        }
        if (snapToSeries && cursorPoint) {
          var snapToSeriesBy = cursor.get("snapToSeriesBy");
          var dataItems = [];
          $array.each(snapToSeries, function (series) {
            if (!series.isHidden() && !series.isHiding()) {
              if (snapToSeriesBy != "x!" && snapToSeriesBy != "y!") {
                var startIndex = series.startIndex();
                var endIndex = series.endIndex();
                for (var i = startIndex; i < endIndex; i++) {
                  var dataItem = series.dataItems[i];
                  if (dataItem && !dataItem.isHidden()) {
                    dataItems.push(dataItem);
                  }
                }
              } else {
                var tooltipDataItem = series.get("tooltipDataItem");
                if (tooltipDataItem) {
                  dataItems.push(tooltipDataItem);
                }
              }
            }
          });
          var minDistance = Infinity;
          var closestItem;
          $array.each(dataItems, function (dataItem) {
            var point = dataItem.get("point");
            if (point) {
              var distance = 0;
              if (snapToSeriesBy == "x" || snapToSeriesBy == "x!") {
                distance = Math.abs(cursorPoint.x - point.x);
              } else if (snapToSeriesBy == "y" || snapToSeriesBy == "y!") {
                distance = Math.abs(cursorPoint.y - point.y);
              } else {
                distance = Math.hypot(cursorPoint.x - point.x, cursorPoint.y - point.y);
              }
              if (distance < minDistance) {
                minDistance = distance;
                closestItem = dataItem;
              }
            }
          });
          $array.each(snapToSeries, function (series) {
            var tooltip = series.get("tooltip");
            if (tooltip) {
              tooltip._setDataItem(undefined);
            }
          });
          if (closestItem) {
            var series = closestItem.component;
            series.showDataItemTooltip(closestItem);
            var point = closestItem.get("point");
            if (point) {
              // removing x and y to solve #72225
              cursor.handleMove(series.toGlobal({
                x: point.x - series.x(),
                y: point.y - series.y()
              }), true);
            }
          }
        }
      }
    }
  }, {
    key: "_updateCursor",
    value: function _updateCursor() {
      var cursor = this.get("cursor");
      if (cursor) {
        cursor.handleMove();
      }
    }
  }, {
    key: "_addCursor",
    value: function _addCursor(cursor) {
      this.plotContainer.children.push(cursor);
    }
  }, {
    key: "_prepareChildren",
    value: function _prepareChildren() {
      var _this7 = this;
      _get(_getPrototypeOf(XYChart.prototype), "_prepareChildren", this).call(this);
      this.series.each(function (series) {
        _this7._colorize(series);
      });
      if (this.isDirty("wheelX") || this.isDirty("wheelY")) {
        this._handleSetWheel();
      }
      if (this.isDirty("cursor")) {
        var previous = this._prevSettings.cursor;
        var cursor = this.get("cursor");
        if (cursor !== previous) {
          this._disposeProperty("cursor");
          if (previous) {
            previous.dispose();
          }
          if (cursor) {
            cursor._setChart(this);
            this._addCursor(cursor);
            this._pushPropertyDisposer("cursor", cursor.events.on("selectended", function () {
              _this7._handleCursorSelectEnd();
            }));
          }
          //this.setRaw("cursor", cursor) // to reset previous value
          this._prevSettings.cursor = cursor;
        }
      }
      if (this.isDirty("scrollbarX")) {
        var _previous = this._prevSettings.scrollbarX;
        var scrollbarX = this.get("scrollbarX");
        if (scrollbarX !== _previous) {
          this._disposeProperty("scrollbarX");
          if (_previous) {
            _previous.dispose();
          }
          if (scrollbarX) {
            if (!scrollbarX.parent) {
              this.topAxesContainer.children.push(scrollbarX);
            }
            this._pushPropertyDisposer("scrollbarX", scrollbarX.events.on("rangechanged", function (e) {
              _this7._handleScrollbar(_this7.xAxes, e.start, e.end, e.grip);
            }));
            // Used to populate `ariaLabel` with meaningful values
            scrollbarX.setPrivate("positionTextFunction", function (position) {
              var axis = _this7.xAxes.getIndex(0);
              return axis ? axis.getTooltipText(position) || "" : "";
            });
          }
          this._prevSettings.scrollbarX = scrollbarX;
        }
      }
      if (this.isDirty("scrollbarY")) {
        var _previous2 = this._prevSettings.scrollbarY;
        var scrollbarY = this.get("scrollbarY");
        if (scrollbarY !== _previous2) {
          this._disposeProperty("scrollbarY");
          if (_previous2) {
            _previous2.dispose();
          }
          if (scrollbarY) {
            if (!scrollbarY.parent) {
              this.rightAxesContainer.children.push(scrollbarY);
            }
            this._pushPropertyDisposer("scrollbarY", scrollbarY.events.on("rangechanged", function (e) {
              _this7._handleScrollbar(_this7.yAxes, e.start, e.end, e.grip);
            }));
            // Used to populate `ariaLabel` with meaningful values
            scrollbarY.setPrivate("positionTextFunction", function (position) {
              var axis = _this7.yAxes.getIndex(0);
              return axis ? axis.getTooltipText(position) || "" : "";
            });
          }
          this._prevSettings.scrollbarY = scrollbarY;
        }
      }
      this._handleZoomOut();
    }
  }, {
    key: "_processSeries",
    value: function _processSeries(series) {
      _get(_getPrototypeOf(XYChart.prototype), "_processSeries", this).call(this, series);
      this._colorize(series);
    }
  }, {
    key: "_colorize",
    value: function _colorize(series) {
      var colorSet = this.get("colors");
      if (colorSet) {
        if (series.get("fill") == null) {
          var color = colorSet.next();
          series._setSoft("stroke", color);
          series._setSoft("fill", color);
        }
      }
    }
  }, {
    key: "_handleCursorSelectEnd",
    value: function _handleCursorSelectEnd() {
      var cursor = this.get("cursor");
      var behavior = cursor.get("behavior");
      var downPositionX = cursor.getPrivate("downPositionX", 0);
      var downPositionY = cursor.getPrivate("downPositionY", 0);
      var positionX = cursor.getPrivate("positionX", 0.5);
      var positionY = cursor.getPrivate("positionY", 0.5);
      this.xAxes.each(function (axis) {
        if (behavior === "zoomX" || behavior === "zoomXY") {
          var position0 = axis.toAxisPosition(downPositionX);
          var position1 = axis.toAxisPosition(positionX);
          axis.zoom(position0, position1);
        }
        axis.setPrivate("updateScrollbar", true);
      });
      this.yAxes.each(function (axis) {
        if (behavior === "zoomY" || behavior === "zoomXY") {
          var position0 = axis.toAxisPosition(downPositionY);
          var position1 = axis.toAxisPosition(positionY);
          axis.zoom(position0, position1);
        }
        axis.setPrivate("updateScrollbar", true);
      });
    }
  }, {
    key: "_handleScrollbar",
    value: function _handleScrollbar(axes, start, end, priority) {
      axes.each(function (axis) {
        var axisStart = axis.fixPosition(start);
        var axisEnd = axis.fixPosition(end);
        var zoomAnimation = axis.zoom(axisStart, axisEnd, undefined, priority);
        var updateScrollbar = "updateScrollbar";
        axis.setPrivateRaw(updateScrollbar, false);
        if (zoomAnimation) {
          zoomAnimation.events.on("stopped", function () {
            axis.setPrivateRaw(updateScrollbar, true);
          });
        } else {
          axis.setPrivateRaw(updateScrollbar, true);
        }
      });
    }
  }, {
    key: "_processAxis",
    value: function _processAxis(axes, container) {
      var _this8 = this;
      return axes.events.onAll(function (change) {
        if (change.type === "clear") {
          $array.each(change.oldValues, function (axis) {
            _this8._removeAxis(axis);
          });
        } else if (change.type === "push") {
          container.children.push(change.newValue);
          change.newValue.processChart(_this8);
        } else if (change.type === "setIndex") {
          container.children.setIndex(change.index, change.newValue);
          change.newValue.processChart(_this8);
        } else if (change.type === "insertIndex") {
          container.children.insertIndex(change.index, change.newValue);
          change.newValue.processChart(_this8);
        } else if (change.type === "removeIndex") {
          _this8._removeAxis(change.oldValue);
        } else if (change.type === "moveIndex") {
          container.children.moveValue(change.value, change.newIndex);
          change.value.processChart(_this8);
        } else {
          throw new Error("Unknown IListEvent type");
        }
      });
    }
  }, {
    key: "_removeAxis",
    value: function _removeAxis(axis) {
      if (!axis.isDisposed()) {
        var axisParent = axis.parent;
        if (axisParent) {
          axisParent.children.removeValue(axis);
        }
        var gridContainer = axis.gridContainer;
        var gridParent = gridContainer.parent;
        if (gridParent) {
          gridParent.children.removeValue(gridContainer);
        }
        var topGridContainer = axis.topGridContainer;
        var topGridParent = topGridContainer.parent;
        if (topGridParent) {
          topGridParent.children.removeValue(topGridContainer);
        }
      }
    }
  }, {
    key: "_updateChartLayout",
    value: function _updateChartLayout() {
      var left = this.leftAxesContainer.width();
      var right = this.rightAxesContainer.width();
      var bottomAxesContainer = this.bottomAxesContainer;
      bottomAxesContainer.set("paddingLeft", left);
      bottomAxesContainer.set("paddingRight", right);
      var topAxesContainer = this.topAxesContainer;
      topAxesContainer.set("paddingLeft", left);
      topAxesContainer.set("paddingRight", right);
    }
    /**
     * @ignore
     */
  }, {
    key: "processAxis",
    value: function processAxis(_axis) {}
  }, {
    key: "_handleAxisSelection",
    value: function _handleAxisSelection(axis, force) {
      var start = axis.fixPosition(axis.get("start", 0));
      var end = axis.fixPosition(axis.get("end", 1));
      if (start > end) {
        var _ref5 = [end, start];
        start = _ref5[0];
        end = _ref5[1];
      }
      if (this.xAxes.indexOf(axis) != -1) {
        if (force || axis.getPrivate("updateScrollbar")) {
          var scrollbarX = this.get("scrollbarX");
          if (scrollbarX && (!scrollbarX.getPrivate("isBusy") || force)) {
            scrollbarX.setRaw("start", start);
            scrollbarX.setRaw("end", end);
            scrollbarX.updateGrips();
          }
        }
      } else if (this.yAxes.indexOf(axis) != -1) {
        if (force || axis.getPrivate("updateScrollbar")) {
          var scrollbarY = this.get("scrollbarY");
          if (scrollbarY && (!scrollbarY.getPrivate("isBusy") || force)) {
            scrollbarY.setRaw("start", start);
            scrollbarY.setRaw("end", end);
            scrollbarY.updateGrips();
          }
        }
      }
      this._handleZoomOut();
    }
  }, {
    key: "_handleZoomOut",
    value: function _handleZoomOut() {
      var zoomOutButton = this.zoomOutButton;
      if (zoomOutButton && zoomOutButton.parent) {
        var visible = false;
        this.xAxes.each(function (axis) {
          if (axis.get("start") != 0 || axis.get("end") != 1) {
            visible = true;
          }
        });
        this.yAxes.each(function (axis) {
          if (axis.get("start") != 0 || axis.get("end") != 1) {
            visible = true;
          }
        });
        if (visible) {
          if (zoomOutButton.isHidden()) {
            zoomOutButton.show();
          }
        } else {
          zoomOutButton.hide();
        }
      }
    }
    /**
     * Checks if point is within plot area.
     *
     * @param   point  Reference point
     * @return         Is within plot area?
     */
  }, {
    key: "inPlot",
    value: function inPlot(point) {
      var plotContainer = this.plotContainer;
      var otherCharts = this.getPrivate("otherCharts", this._otherCharts);
      var global = plotContainer.toGlobal(point);
      if (point.x >= -0.5 && point.y >= -0.5 && point.x <= plotContainer.width() + 0.5 && point.y <= plotContainer.height() + 0.5) {
        return true;
      }
      if (otherCharts) {
        for (var i = otherCharts.length - 1; i >= 0; i--) {
          var chart = otherCharts[i];
          if (chart != this) {
            var chartPlotContainer = chart.plotContainer;
            var documentPoint = this._root.rootPointToDocument(global);
            var chartRoot = chart._root.documentPointToRoot(documentPoint);
            var local = chartPlotContainer.toLocal(chartRoot);
            if (local.x >= -0.1 && local.y >= -0.1 && local.x <= chartPlotContainer.width() + 0.1 && local.y <= chartPlotContainer.height() + 0.1) {
              return true;
            }
          }
        }
      }
      return false;
    }
    /**
     * @ignore
     */
  }, {
    key: "arrangeTooltips",
    value: function arrangeTooltips() {
      var _this9 = this;
      var plotContainer = this.plotContainer;
      var w = plotContainer.width();
      var h = plotContainer.height();
      var hh = this.height();
      var plotT = plotContainer._display.toGlobal({
        x: 0,
        y: 0
      });
      var plotB = plotContainer._display.toGlobal({
        x: w,
        y: h
      });
      var tooltips = [];
      var sum = 0;
      var minDistance = Infinity;
      var movePoint = this._movePoint;
      var maxTooltipDistance = this.get("maxTooltipDistance");
      var maxTooltipDistanceBy = this.get("maxTooltipDistanceBy", "xy");
      var closest;
      var closestPoint;
      if ($type.isNumber(maxTooltipDistance)) {
        this.series.each(function (series) {
          if (!series.isHidden()) {
            var tooltip = series.get("tooltip");
            if (tooltip) {
              var point = tooltip.get("pointTo");
              if (point) {
                var distance = Math.hypot(movePoint.x - point.x, movePoint.y - point.y);
                if (maxTooltipDistanceBy == "x") {
                  distance = Math.abs(movePoint.x - point.x);
                } else if (maxTooltipDistanceBy == "y") {
                  distance = Math.abs(movePoint.y - point.y);
                }
                if (distance < minDistance) {
                  minDistance = distance;
                  closest = series;
                  closestPoint = point;
                }
              }
            }
          }
        });
      }
      var tooltipSeries = [];
      this.series.each(function (series) {
        var tooltip = series.get("tooltip");
        if (tooltip) {
          var hidden = false;
          var point = tooltip.get("pointTo");
          if (point) {
            if (maxTooltipDistance >= 0) {
              var _point = tooltip.get("pointTo");
              if (_point) {
                if (series != closest) {
                  var distance = Math.hypot(closestPoint.x - _point.x, closestPoint.y - _point.y);
                  if (maxTooltipDistanceBy == "x") {
                    distance = Math.abs(closestPoint.x - _point.x);
                  } else if (maxTooltipDistanceBy == "y") {
                    distance = Math.abs(closestPoint.y - _point.y);
                  }
                  if (distance > maxTooltipDistance) {
                    hidden = true;
                  }
                }
              }
            } else if (maxTooltipDistance == -1) {
              if (series != closest) {
                hidden = true;
              }
            }
            if (!_this9.inPlot(_this9._tooltipToLocal(point)) || !tooltip.dataItem) {
              hidden = true;
            } else {
              if (!hidden) {
                sum += point.y;
              }
            }
            if (hidden || series.isHidden() || series.isHiding()) {
              tooltip.hide(0);
            } else {
              tooltip.show();
              tooltips.push(tooltip);
              tooltipSeries.push(series);
            }
          }
        }
      });
      this.setPrivate("tooltipSeries", tooltipSeries);
      if (this.get("arrangeTooltips")) {
        var tooltipContainer = this._root.tooltipContainer;
        var count = tooltips.length;
        var average = sum / count;
        if (average > h / 2 + plotT.y) {
          tooltips.sort(function (a, b) {
            return $order.compareNumber(b.get("pointTo").y, a.get("pointTo").y);
          });
          var prevY = plotB.y;
          $array.each(tooltips, function (tooltip) {
            var height = tooltip.height();
            var centerY = tooltip.get("centerY");
            if (centerY instanceof Percent) {
              height *= centerY.value;
            }
            height += tooltip.get("marginBottom", 0);
            tooltip.set("bounds", {
              left: plotT.x,
              top: plotT.y,
              right: plotB.x,
              bottom: prevY
            });
            tooltip.setPrivate("customData", {
              left: plotT.x,
              top: plotT.y,
              right: plotB.x,
              bottom: prevY
            });
            prevY = Math.min(prevY - height, tooltip._fy - height);
            if (tooltip.parent == tooltipContainer) {
              tooltipContainer.children.moveValue(tooltip, 0);
            }
          });
          if (prevY < 0) {
            tooltips.reverse();
            var prevBottom = prevY;
            $array.each(tooltips, function (tooltip) {
              var bounds = tooltip.get("bounds");
              if (bounds) {
                var top = bounds.top - prevY;
                var bottom = bounds.bottom - prevY;
                if (top < prevBottom) {
                  top = prevBottom;
                  bottom = top + tooltip.height();
                }
                tooltip.set("bounds", {
                  left: bounds.left,
                  top: top,
                  right: bounds.right,
                  bottom: bottom
                });
                prevBottom = bounds.bottom - prevY + tooltip.get("marginBottom", 0);
              }
            });
          }
        } else {
          tooltips.reverse();
          tooltips.sort(function (a, b) {
            return $order.compareNumber(a.get("pointTo").y, b.get("pointTo").y);
          });
          var _prevY = 0;
          $array.each(tooltips, function (tooltip) {
            var height = tooltip.height();
            var centerY = tooltip.get("centerY");
            if (centerY instanceof Percent) {
              height *= centerY.value;
            }
            height += tooltip.get("marginBottom", 0);
            tooltip.set("bounds", {
              left: plotT.x,
              top: _prevY,
              right: plotB.x,
              bottom: Math.max(plotT.y + hh, _prevY + height)
            });
            if (tooltip.parent == tooltipContainer) {
              tooltipContainer.children.moveValue(tooltip, 0);
            }
            _prevY = Math.max(_prevY + height, tooltip._fy + height);
          });
          if (_prevY > hh) {
            tooltips.reverse();
            var _prevBottom = hh;
            $array.each(tooltips, function (tooltip) {
              var bounds = tooltip.get("bounds");
              if (bounds) {
                var top = bounds.top - (hh - _prevY);
                var bottom = bounds.bottom - (hh - _prevY);
                if (bottom > _prevBottom) {
                  bottom = _prevBottom;
                  top = bottom - tooltip.height();
                }
                tooltip.set("bounds", {
                  left: bounds.left,
                  top: top,
                  right: bounds.right,
                  bottom: bottom
                });
                _prevBottom = bottom - tooltip.height() - tooltip.get("marginBottom", 0);
              }
            });
          }
        }
      }
    }
  }, {
    key: "_tooltipToLocal",
    value: function _tooltipToLocal(point) {
      return this.plotContainer.toLocal(point);
    }
    /**
     * Fully zooms out the chart.
     */
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      this.xAxes.each(function (axis) {
        axis.setPrivate("updateScrollbar", true);
        axis.zoom(0, 1);
      });
      this.yAxes.each(function (axis) {
        axis.setPrivate("updateScrollbar", true);
        axis.zoom(0, 1);
      });
    }
  }]);
  return XYChart;
}(SerialChart);
Object.defineProperty(XYChart, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "XYChart"
});
Object.defineProperty(XYChart, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: SerialChart.classNames.concat([XYChart.className])
});